import { connect } from 'react-redux';
import {
    VARIANT_ON,
    EAT_SITE_FOOTER_CONTACT_INFO,
    API_DOCS_LINK_IN_FOOTER,
} from '@zocdoc-frontend-common/utils-ab/constants';
import Footer from './Footer';

const mapStateToProps = (state) => {
    return {
        isSiteFooterContactLinkGroupEnabled:
            state.absystem?.[EAT_SITE_FOOTER_CONTACT_INFO.experimentId] ===
            VARIANT_ON,
        isSiteFooterDevelopersForAllLinkEnabled:
            state.absystem?.[API_DOCS_LINK_IN_FOOTER.experimentId] ===
            VARIANT_ON,
    };
};

export default connect(mapStateToProps)(Footer);
